import { render, staticRenderFns } from "./TransportFeeReport.vue?vue&type=template&id=3899cc03&scoped=true"
import script from "./TransportFeeReport.vue?vue&type=script&lang=js"
export * from "./TransportFeeReport.vue?vue&type=script&lang=js"
import style0 from "./TransportFeeReport.vue?vue&type=style&index=0&id=3899cc03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3899cc03",
  null
  
)

export default component.exports